import React, {useEffect, useState, useRef } from "react";
import "./Header.css";
import {Contacts} from "./Contacts";
import {Menu} from "./Menu";
import {Language} from "./Language";
import { ReactComponent as BurgerIcon } from "../../icons/burger.svg";
import { ReactComponent as CloseIcon } from "../../icons/cancel.svg";


export const Header = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1279);
    const [menuOpen, setMenuOpen] = useState(false);

    const menuRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1279);
            setMenuOpen(false);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };

        if (menuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen]);

    return (
        <div className="headerContainer">
        <div className="header">
            <div className="logoLang">
                    <a href="/" className="page-scroll noPad">
                        <div className={'logoDiv'} />
                    </a>
                <Language />
            </div>
            {isMobile ? (
                <>
                    <div className="burgerIcon" onClick={() => setMenuOpen(!menuOpen)}>
                        {menuOpen ? <CloseIcon /> : <BurgerIcon />}
                    </div>
                </>
            ) : (
                <>
                    <Menu />
                    <Contacts onLinkClick={() => setMenuOpen(false) }/>
                </>
            )}
        </div>
    {isMobile && menuOpen && (
        <div className={`mobileMenu open`} ref={menuRef}>
            <Menu onLinkClick={() => setMenuOpen(false) }/>
            <Contacts onLinkClick={() => setMenuOpen(false) }/>
        </div>
    )}
        </div>
    );
};
